"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgGoogleDark = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M16 7.41a6 6 0 0 0-3.768-1.32c-2.684 0-4.946 1.696-5.74 4.053A5.801 5.801 0 0 0 6.187 12c0 .646.109 1.267.304 1.848l-1.721 1.29-1.721 1.289A9.82 9.82 0 0 1 2 12a9.82 9.82 0 0 1 1.05-4.43C4.712 4.263 8.187 2 12.231 2c2.605 0 4.93.955 6.744 2.5L16 7.41Z", fill: "#333" }),
        React.createElement("path", { d: "M12.232 17.91c-2.684 0-4.946-1.696-5.74-4.054L4.77 15.137l-1.721 1.29v.003C4.714 19.737 8.189 22 12.233 22c2.496 0 4.879-.867 6.667-2.492l-3.269-2.473c-.922.568-2.084.874-3.398.874Z", fill: "#333" }),
        React.createElement("path", { d: "M21.767 10.182c.14.59.233 1.227.233 1.818 0 3.26-1.222 5.801-3.1 7.508l-3.27-2.473a4.505 4.505 0 0 0 2.09-2.99h-5.488v-3.863h9.535Z", fill: "#333" })));
};
exports.default = factorySvgIcon_1.default(SvgGoogleDark);
//# sourceMappingURL=SvgGoogleDark.js.map